class ScreenService {
  private screenWidth: number;

  constructor() {
    this.screenWidth = window.innerWidth;
  }

  isMobile(): boolean {
    return this.screenWidth < 768;
  }
}

const screenService = new ScreenService();
export default screenService;
